<div class='doctors-main ui-dark-background' style="display: flex; flex-direction: column; height: 100%;" data-cy="doctors-container">
  <mat-progress-spinner *ngIf="isLoading"
    style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%);"
    diameter="100" mode="indeterminate" data-cy="doctors-loading-spinner"></mat-progress-spinner>
  <mat-grid-list *ngIf="!isLoading" [cols]="colspan" rowHeight="100%" style="height:100%;" data-cy="doctors-grid">
    <mat-grid-tile *ngIf="!isFrontDeskReferral" style="display: flex; flex-direction: column; height: 100%;"
      colspan="2" data-cy="doctors-list-tile">
      <mat-card appearance="outlined" style="width:100%; height: 100%; max-height: 100%; flex: 1; overflow: hidden;" data-cy="doctors-list-card">
        <span *ngIf="doctorType === routeParamsDoctorTypeProviders" class="configuration-section-title" data-cy="doctors-provider-title">Provider Doctors</span>
        <span *ngIf="doctorType !== routeParamsDoctorTypeProviders" class="configuration-section-title" data-cy="doctors-referral-title">Referral Doctors</span>
        <div style="height: 96%;" data-cy="doctors-table-container">
          <tdo-table #doctorTable [dataSource]="doctorList" [sortPredicate]="sortPredicate" sortActive="FirstName"
            sortDirection="asc" (rowSelected)="onTdoTableItemClick1($event)" data-cy="doctors-table">
            <tdo-table-column displayName="First" propertyName="FirstName" targetObjectName="dataContact"
              [isSortable]="true" [rowTemplate]="firstName" data-cy="doctors-column-first">
              <ng-template #firstName let-row>
                {{row.model.dataContact ? (row.model.dataContact.FirstName ? row.model.dataContact.FirstName : '') : ''}}
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Last" propertyName="LastName" targetObjectName="dataContact"
              [isSortable]="true" [rowTemplate]="lastName" data-cy="doctors-column-last">
              <ng-template #lastName let-row>
                {{row.model.dataContact.LastName}}
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Status" propertyName="enumDoctorTypeID" [isSortable]="true"
              [rowTemplate]="provider" data-cy="doctors-column-status">
              <ng-template #provider let-row>
                <ng-container *ngIf="row.model.enumDoctorTypeID === '00000004-1000-0000-0000-000000000001'">
                  <img [matTooltip]="row.model.isActiveDoctor ? 'Doctor is active' : 'Doctor is inactive'"
                    [ngStyle]="{'opacity': row.model.isActiveDoctor ? 1 : 0.25}" style="height: 12px;"
                    src="assets/Images/navbar-icons/v2/new_tdo_logo.svg" data-cy="doctors-status-icon" />
                </ng-container>
              </ng-template>
            </tdo-table-column>
            <!--<tdo-table-column displayName="Status" propertyName="isActiveDoctor" [isSortable]="true" [rowTemplate]="active">
              <ng-template #active let-row>
                <ng-container *ngIf="row.model.enumDoctorTypeID === '00000004-1000-0000-0000-000000000001'">
                  <div style="width: 20px; text-align: center; margin-top: 9px;"><mat-checkbox [checked]="row.model.isActiveDoctor" (change)="onDoctorStatusChange(row.model)"></mat-checkbox></div>
                </ng-container>
              </ng-template>
            </tdo-table-column>-->
            <tdo-table-column displayName="" propertyName="xauditDeleted" [isSortable]="false" [rowTemplate]="actions" data-cy="doctors-column-actions">
              <ng-template #actions let-row>
                <div
                  [matTooltip]="'Delete ' + row.model.dataContact.FirstName + ' ' + row.model.dataContact.LastName + '?'"
                  style="max-width: 10px; margin-top: 6px; cursor: pointer; color: var(--tdo-secondary); text-align: right;"
                  (click)="onDeleteDoctor(row, $event)" data-cy="doctors-delete-btn"><mat-icon>delete</mat-icon></div>
              </ng-template>
            </tdo-table-column>
          </tdo-table>
        </div>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile colspan="5" data-cy="doctors-details-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="doctors-details-card">
        <span class="configuration-section-title" data-cy="doctors-details-title">Doctor Information</span>
        <app-tdo-configuration-action-bar (newClick)="onNewDoctor()"
          (saveClick)="onSave($event)" data-cy="doctors-action-bar"></app-tdo-configuration-action-bar>
        <mat-card-content *ngIf="selectedDoctor" data-cy="doctors-details-content">
          <div style="display: flex;" data-cy="doctors-name-row">
            <app-validvalueselect [style]="'width: 100%;'" style="flex-basis: 30px; position: relative; top: 0;"
              validvaluename="enumSalutation" vvplaceholder="Salutation" vvlabel="Salutation"
              validvaluename="enumSalutation" vvplaceholder="Salutation" vvlabel="Salutation"
              [(selectedValue)]="selectedDoctor.dataContact.enumSalutationID"
              selectedValueChange="" data-cy="doctors-salutation-select"></app-validvalueselect>
            <mat-form-field style="flex: 1; margin-left: 5px;" data-cy="doctors-firstname-field">
              <mat-label data-cy="doctors-firstname-label">First Name:</mat-label>
              <input matInput placeholder="First Name" [value]="selectedDoctor.dataContact.FirstName"
                (input)="selectedDoctor.dataContact.FirstName = $event.target.value; onInput()" data-cy="doctors-firstname-input" />

            </mat-form-field>

            <mat-form-field style="flex: 1; margin-left: 5px;" data-cy="doctors-midname-field">
              <mat-label data-cy="doctors-midname-label">MidName:</mat-label>
              <input matInput placeholder="MidName" [value]="selectedDoctor.dataContact.MidName"
                (input)="selectedDoctor.dataContact.MidName = $event.target.value" data-cy="doctors-midname-input" />
            </mat-form-field>
            <mat-form-field style="flex: 1; margin-left: 5px;" data-cy="doctors-lastname-field">
              <mat-label data-cy="doctors-lastname-label">Last Name:</mat-label>
              <input matInput type="text" [value]="selectedDoctor.dataContact.LastName"
                (input)="selectedDoctor.dataContact.LastName = $event.target.value; onInput()" data-cy="doctors-lastname-input">
            </mat-form-field>
            <app-validvalueselect [style]="'width: 100%;'" style="flex: 1; margin-left: 5px;"
              validvaluename="enumNameSuffix" vvplaceholder="Suffix" vvlabel="Suffix"
              [(selectedValue)]="selectedDoctor.dataContact.enumNameSuffixID"
              selectedValueChange="" data-cy="doctors-suffix-select"></app-validvalueselect>
          </div>

          <div style="display: flex; margin-top: 20px;" data-cy="doctors-details-row">
            <app-validvalueselect [style]="'width: 100%;'"
              style="flex-basis: 40px; margin-right: 5px; position: relative; top: -0.5px;" validvaluename="enumGender"
              vvplaceholder="Gender" vvlabel="Gender" [(selectedValue)]="selectedDoctor.dataContact.enumGenderID"
              selectedValueChange="" data-cy="doctors-gender-select"></app-validvalueselect>
            <app-validvalueselect style="flex-basis: 40px; margin-left: 2px; margin-right: 4px;" [style]="'width:100%'"
              validvaluename="enumDoctorClassification" vvplaceholder="Classification" vvlabel="Classification"
              [(selectedValue)]="selectedDoctor.enumDoctorClassificationID"
              selectedValueChange="" data-cy="doctors-classification-select"></app-validvalueselect>
            <button style="margin-bottom: 14px; margin-left: 8px;" class="tdo-button tdo-save"
              (click)="openEditContact(selectedDoctor)" data-cy="doctors-edit-contact-btn">Edit Contact Details</button>
            <app-tdo-dropdown *ngIf="doctorType === routeParamsDoctorTypeProviders" style="position: relative; margin-left: 8px; top: -6px;" matTooltip="Lists Doctor Users Only (Group)"
                              placeholder="User Account" tdolabel="User Account" [dataSource]="userList" [isObjectValue]="true"
                              dataSourceDisplayKey="UserName" [value]="getUser()" (valueChange)="onUserSelectionChange($event)" data-cy="doctors-user-dropdown">
            </app-tdo-dropdown>
            <ng-container *ngIf="doctorType !== routeParamsDoctorTypeProviders">
              <mat-form-field style="flex: 1; margin-left: 5px;" data-cy="doctors-username-field">
                <mat-label data-cy="doctors-username-label">Username:</mat-label>
                <input matInput [value]="selectedDoctor.UserName" readonly="true" data-cy="doctors-username-input" />
              </mat-form-field>
              <button style="margin-bottom: 14px; margin-left: 8px;" [disabled]="isResettingCredentials"
                class="tdo-button tdo-save" (click)="resetCredentials()" data-cy="reset-credentials-button">
                <span *ngIf="!isResettingCredentials">Reset Credentials</span>
                <mat-spinner class="login-spinner" *ngIf="isResettingCredentials" [diameter]="20" data-cy="doctors-reset-spinner"></mat-spinner>
              </button>
            </ng-container>
          </div>
          <div *ngIf="selectedDoctor && selectedDoctor.enumDoctorTypeID == '00000004-1000-0000-0000-000000000001'"
            style="color: var(--tdo-primary);" data-cy="doctors-active-container"><mat-checkbox [checked]="selectedDoctor.isActiveDoctor === true"
              (change)="onDoctorStatusChange($event, selectedDoctor)" data-cy="doctors-active-checkbox">Active</mat-checkbox></div>
          <div *ngIf="selectedDoctor && selectedDoctor.enumDoctorTypeID != '00000004-1000-0000-0000-000000000001'"
               style="color: var(--tdo-primary);" data-cy="doctors-type-container">
            <mat-radio-group
              aria-labelledby="doctor types"
              [(ngModel)]="selectedDoctor.enumDoctorTypeID" data-cy="doctors-type-radio-group">
              <mat-radio-button  *ngFor="let ref of refDoctorTypesList; let i = index" [value]="ref.enumDoctorTypeID" data-cy="doctors-type-radio-{{i}}">
                {{ref.ItemDisplayValue}}
              </mat-radio-button>
            </mat-radio-group>
          </div>


          <mat-tab-group style="height: 100%;" data-cy="doctors-tabs">
            <mat-tab label="Specialty" data-cy="doctors-specialty-tab">
<!--              <mat-selection-list #specialties style="width:50%" [(ngModel)]="selectedDoctorsSpecialtyEnumList">-->
<!--                <mat-list-option *ngFor="let value of specialtyEnumList" value="{{value.ValidValueItemId}}">-->
<!--                  {{value.ItemDisplayValue}}-->
<!--                </mat-list-option>-->
<!--              </mat-selection-list>-->

                    <mat-list #specialties style="width:50%" data-cy="doctors-specialty-list">
                      <mat-list-item *ngFor="let value of specialtyEnumList; let i = index" data-cy="doctors-specialty-item-{{i}}">
                        <div style=" display: flex;" data-cy="doctors-specialty-item-content-{{i}}">
                          <span style="width: 200px;" data-cy="doctors-specialty-name-{{i}}">{{value.ItemDisplayValue}}</span>
                          <mat-checkbox style="width: 100px;" [(ngModel)]="value.isSelected" data-cy="doctors-specialty-select-{{i}}">Select</mat-checkbox>
                          <mat-checkbox style="width: 100px;" *ngIf="value.isSelected==true" [checked]="selected === i" (change)="selected = i" [(ngModel)]="value.isPrimary" data-cy="doctors-specialty-primary-{{i}}">Primary</mat-checkbox>
                        </div>
                      </mat-list-item>
                    </mat-list>




            </mat-tab>
            <mat-tab style="height: 100%; width: 100%; overflow-y: hidden;"
              *ngIf="selectedDoctor && selectedDoctor.enumDoctorTypeID == '00000004-1000-0000-0000-000000000001'"
              label="Licenses" data-cy="doctors-licenses-tab">
              <div style="height: 420px; max-height: 420px; width: 100%; overflow-y: hidden;" data-cy="doctors-licenses-container">
                <div style="display: flex; margin-top: 4px;" data-cy="doctors-licenses-header">
                  <div style="flex: 1;"></div>
                  <div matTooltip="Add license"
                    style="flex-basis: fit-content; cursor: pointer; color: var(--tdo-primary);" (click)="addLicense()" data-cy="doctors-add-license-btn">
                    <mat-icon>add_circle_outline</mat-icon></div>
                </div>


                <tdo-table #licenseTable [isSearchable]="false" [dataSource]="this.selectedDoctor.dataDoctorLicences" data-cy="doctors-licenses-table">
                  <tdo-table-column displayName="License Number" propertyName="LicenceNumber" isSortable="true"
                    [rowTemplate]="licenseNumber" data-cy="doctors-license-number-column">
                    <ng-template #licenseNumber let-row>
                      <input class="doctor-license-input" [(ngModel)]="row.model.LicenceNumber"
                        (appInputFinished)="onLicenseInputFinished($event, row)" data-cy="doctors-license-number-input">
                    </ng-template>
                  </tdo-table-column>
                  <tdo-table-column displayName="State" propertyName="enumLicenceStateID" isSortable="true"
                    [rowTemplate]="state" data-cy="doctors-license-state-column">
                    <ng-template #state let-row >
                      <app-validvalueselect
                        style="flex: 1; margin-left: 2px; margin-top: 2px; height: 30px; overflow-y: hidden; margin-right: 4px ; width: 150px;"
                        (selectedValueChange)="onLicenseStateChange($event, row)" [dataSource]="stateEnums"
                        validvaluename="enumStateProvince" vvplaceholder="State"
                        [(selectedValue)]="row.model.enumLicenceStateID" data-cy="doctors-license-state-select"></app-validvalueselect>
                      <!--                      [style]="'width:100%'"-->
                      <!--                      <input class="doctor-license-input" [(ngModel)]="row.model.enumLicenceStateID" (appInputFinished)="onLicenseInputFinished($event, row)">-->
                    </ng-template>
                  </tdo-table-column>
                  <tdo-table-column displayName="Tax ID" propertyName="TaxID" isSortable="true" [rowTemplate]="taxid" data-cy="doctors-license-taxid-column">
                    <ng-template #taxid let-row>
                      <input class="doctor-license-input" [(ngModel)]="row.model.TaxID"
                        (appInputFinished)="onLicenseInputFinished($event, row)" style="margin-right: 4px" data-cy="doctors-license-taxid-input">
                    </ng-template>
                  </tdo-table-column>
                  <tdo-table-column displayName="DEA" propertyName="DEA" isSortable="true" [rowTemplate]="dea" data-cy="doctors-license-dea-column">
                    <ng-template #dea let-row>
                      <input class="doctor-license-input" [(ngModel)]="row.model.DEA"
                        (appInputFinished)="onLicenseInputFinished($event, row)" style="margin-right: 4px" data-cy="doctors-license-dea-input">
                    </ng-template>
                  </tdo-table-column>
                  <tdo-table-column displayName="NPI" propertyName="NPI" isSortable="true" [rowTemplate]="npi" data-cy="doctors-license-npi-column">
                    <ng-template #npi let-row>
                      <input class="doctor-license-input" [(ngModel)]="row.model.NPI"
                        (appInputFinished)="onLicenseInputFinished($event, row)" style="margin-right: 4px" data-cy="doctors-license-npi-input">
                    </ng-template>
                  </tdo-table-column>

                  <tdo-table-column displayName="Other" propertyName="CustomParamsJSON" isSortable="true" [rowTemplate]="other" data-cy="doctors-license-other-column">
                    <ng-template #other let-row>
                      <input class="doctor-license-other-input" [(ngModel)]="row.model.CustomParamsJSON"
                        (appInputFinished)="onLicenseInputFinished($event, row)" style="margin-right: 4px" data-cy="doctors-license-other-input">
                    </ng-template>
                  </tdo-table-column>


                  <tdo-table-column displayName="" propertyName="xauditDeleted" isSortable="false"
                    [rowTemplate]="actions" data-cy="doctors-license-actions-column">
                    <ng-template #actions let-row>
                      <div matTooltip="Delete Row" (click)="deleteLicense(row.model)"
                        style="color: var(--tdo-secondary); text-align: right; margin-top: 4px;" data-cy="doctors-license-delete-btn">
                        <mat-icon>delete</mat-icon></div>
                    </ng-template>
                  </tdo-table-column>
                </tdo-table>


              </div>
            </mat-tab>


            <mat-tab *ngIf="selectedDoctor && selectedDoctor.enumDoctorTypeID != '00000004-1000-0000-0000-000000000001'"
                     label="For Locations" data-cy="doctors-locations-tab">

              Visible at Locations


              <dx-list
                [dataSource]="selectedDoctor.dataDoctorRefLocations"
                [showSelectionControls]="'true'"
                [height]="500"
                [pageLoadMode]="'scroll'"
                itemTemplate="listItem"
                data-cy="doctors-ref-locations-list">
                <div *dxTemplate="let item of 'listItem'" data-cy="doctors-ref-locations-item">

                  <mat-checkbox [checked]="item.isSeleted" (change)="onRefLocChange($event, item)" data-cy="doctors-ref-locations-checkbox"></mat-checkbox>
                  {{item.locDescription}}


                </div>
              </dx-list>


            </mat-tab>

            <mat-tab *ngIf="selectedDoctor && selectedDoctor.enumDoctorTypeID == '00000004-1000-0000-0000-000000000001'"
              label="Locations" data-cy="doctors-provider-locations-tab">
              <div style="display: flex;" data-cy="doctors-provider-locations-container">
                <div style="margin:10px; flex-basis: 120px; padding-right: 15px; border-right: 2px solid var(--tdo-primary-accent);" data-cy="doctors-provider-locations-selects">
                  <mat-form-field style="width:100%" data-cy="doctors-provider-practice-field">
                    <mat-label data-cy="doctors-provider-practice-label">TDO Practice</mat-label>
                    <mat-select [value]="selectedClient" (selectionChange)="onChangeClient($event)" data-cy="doctors-provider-practice-select">
                      <mat-option *ngFor="let client of clientList" [value]="client" data-cy="doctors-provider-practice-option-{{client.Name}}">
                        {{client.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field style="width:100%" data-cy="doctors-provider-location-field">
                    <mat-label data-cy="doctors-provider-location-label">Location</mat-label>
                    <mat-select [ngModel]="selectedClientLocation"
                      (selectionChange)="onLocationSelectionChanged($event)" data-cy="doctors-provider-location-select">
                      <mat-option *ngFor="let loc of locationList" [value]="loc" data-cy="doctors-provider-location-option-{{loc.Name}}">
                        {{loc.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div style="margin-top: 10px; flex-basis: 320px;">

                  <mat-form-field style="width:100%">
                    <mat-label>Checking Account</mat-label>
                    <mat-select (selectionChange)="onSelectedCheckAccountChanged($event)"
                                [value]="selectedArCheckAccountConfig">
                      <mat-option *ngFor="let acc of arConfigurationAccounts" [value]="acc">
                        {{acc.AccountName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>


                  <mat-form-field style="width:100%">
                    <mat-label>AR Account</mat-label>
                    <mat-select (selectionChange)="onSelectedArAccountChanged($event)"
                                [value]="selectedArAccountConfig">
                      <mat-option *ngFor="let acc of arConfigurationAccounts" [value]="acc">
                        {{acc.AccountName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field style="width:100%" *ngIf="selectedArAccountConfig != null">
                    <mat-label>Accounting Integration</mat-label>
                    <mat-select (selectionChange)="onSelectedEnumARIntegrationID($event)"
                                [value]="selectedARIntegrationEnumList">
                      <mat-option *ngFor="let value of arIntegrationEnumList" value="{{value.ValidValueItemId}}">
                        {{value.ItemDisplayValue}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <div *ngIf="isQuickbooksIntegration" style="padding: 15px; border: 2px solid var(--tdo-primary-accent);">
                    <h6>Quick Books Pro</h6>
                    <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;">
                      <mat-label>Start Date</mat-label>
                      <input matInput [matDatepicker]="dateStartARPicker" [(ngModel)]="selectedDoctorARLocation.ARSystemIntegrationStart">
                      <mat-datepicker-toggle matSuffix [for]="dateStartARPicker"></mat-datepicker-toggle>
                      <mat-datepicker #dateStartARPicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field style="flex: 1; margin-left: 5px; width: 100%;">
                      <mat-label>Class:</mat-label>
                      <input matInput placeholder="Class" [value]="selectedQuickBooks.Class"
                             (input)="selectedQuickBooks.Class = $event.target.value; quickBooksChange(); onInput()" />
                    </mat-form-field>

                    <mat-form-field style="width:100%">
                      <mat-label>Sales Account</mat-label>
                      <mat-select (selectionChange)="onSelectedQBSalesAccount($event)"
                                  [value]="selectedQBSalesAccount">
                        <mat-option *ngFor="let acc of arConfigurationAccounts" [value]="acc">
                          {{acc.AccountName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field style="width:100%">
                      <mat-label>Checking Account</mat-label>
                      <mat-select (selectionChange)="onSelectedQBCheckingAccount($event)"
                                  [value]="selectedQBCheckingAccount">
                        <mat-option *ngFor="let acc of arConfigurationAccounts" [value]="acc">
                          {{acc.AccountName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field style="flex: 1; margin-left: 5px; width: 100%;">
                      <mat-label>User Name:</mat-label>
                      <input matInput placeholder="User Name" [value]="selectedQuickBooks.UserName"
                             (input)="selectedQuickBooks.UserName = $event.target.value; quickBooksChange(); onInput()" />
                    </mat-form-field>

                    <mat-form-field style="flex: 1; margin-left: 5px; width: 100%;">
                      <mat-label>Password/Key:</mat-label>
                      <input matInput placeholder="Password/Key" [value]="selectedQuickBooks.Password"
                             (input)="selectedQuickBooks.Password = $event.target.value; quickBooksChange(); onInput()" />
                    </mat-form-field>
                  </div>
                </div>
                <div style="flex-basis: 400px">
                  <div style="margin-left: 30px; margin-top: 10px;">
                    Workdays at Location: {{ selectedClientLocation ? (selectedClientLocation.Name ? selectedClientLocation.Name : '') : ''}}
                    <div *ngFor="let weekDay of weekDaysEnumList">
                      <mat-checkbox color="primary" [value]="weekDay.ValidValueItemId"
                                    [checked]="isWeekdayChecked(weekDay)"
                                    (change)="onSelectWeekDay($event.checked, weekDay)">
                        {{weekDay.ItemDisplayValue}}  {{this.getLocationWorkingByDay(weekDay)}}
                      </mat-checkbox>
                    </div>
                  </div>




                  <div style="margin-left: 30px; margin-top: 10px; background-color: #00ffbd"  *ngIf="selectedArAccountConfig != null">
<!--                    Payment Processors-->
                    <span style="font-weight: bold">Doctors Payment Processors: {{selectedClientLocation.Name}}</span>

                    <div style="height: 100px; overflow-y: auto; border: #00a8ff">

<!--                    <mat-list role="list"  *ngFor="let p of doctorArLocationPaymentProcessors"  style="padding-top: 0; padding-bottom: 2px " >-->
<!--                      <mat-list-item role="listitem">-->

<!--                        <div style="display: flex;   height: 24px;  ">-->
<!--                          <div style="width: 200px; ">-->
<!--                            {{p.PaymentProcessorName}}-->

<!--                          </div>-->

<!--                          <div-->
<!--                            style="max-width: 20px;  cursor: pointer; color: var(&#45;&#45;tdo-secondary); text-align: right;"-->
<!--                            (click)="onDeletePaymentProcessor(row, $event)"><mat-icon>delete</mat-icon>-->
<!--                          </div>-->
<!--                        </div>-->

<!--                      </mat-list-item>-->
<!--                    </mat-list>-->

                      <mat-selection-list #payproc [multiple]="false"    style="padding-top: 0; padding-bottom: 0px " >


                        <mat-list-option *ngFor="let p of doctorArLocationPaymentProcessors " [value]="p"  style="height: 24px">

                          <div style="display: flex;   height: 24px;  " *ngIf="p.xauditDeleted==false" >
                            <div style="width: 300px; ">
                              {{p.PaymentProcessorName}}

                            </div>

                            <div
                              style="max-width: 28px;  cursor: pointer; color: var(--tdo-secondary); text-align: right;"
                              >
                              <button mat-icon-button (click)="onDeletePaymentProcessor(p, $event)">
                                <mat-icon >delete</mat-icon>
                              </button>
                            </div>
                          </div>

                        </mat-list-option>

                      </mat-selection-list>



                    </div>

<!--                    <img src="/assets/icons/icons8_add_new_add.svg"   style="width: 24px; height: 24px;">-->

                    <div
                      style="max-width: 10px; margin-top: 6px; cursor: pointer; color: var(--tdo-secondary); text-align: right;"
                      (click)="onAddPaymentProcessorVisible(row, $event)"><mat-icon>add</mat-icon>
                    </div>

                    <div *ngIf="this.isPaymentProcessorVisible"  style="height: 200px;  overflow-y: auto;  background-color:#a0ffbd; border: #00a8ff; border-width: 5px;" >
                      <span style="font-weight: bold">Select a Payment Processor to add</span>

                      <mat-selection-list #payprocopt [multiple]="false"    style="padding-top: 0; padding-bottom: 0px ; margin: 5px;"  >


                        <mat-list-option *ngFor="let p of cfgARPaymentProcessors " [value]="p"  style="height: 24px" (click)="onNgModelChangecfgARPaymentProcessors($event, p)" >

                          <div style="display: flex;   height: 24px;  ">
                            <div style="width: 300px; ">
                              {{p.Name}}
                            </div>
                          </div>

                        </mat-list-option>

                      </mat-selection-list>
                      <button mat-flat-button color="primary" (click)="onAddPaymentProcessor()">Add</button>


                    </div>



                  </div>
                </div>

              </div>
            </mat-tab>






            <mat-tab label="Images" data-cy="doctors-images-tab">
              <input #fileInput id="fileInput" style="display:none;" type="file" [accept]="filetypes"
                (change)="fileSelected(fileInput.files)" data-cy="doctors-file-input" />
              <div class="logos" style="margin-top: 20px;" data-cy="doctors-images-container">
                <div class="logo-item" style="margin-right: 15px;" data-cy="doctors-portrait-container">
                  <div class="logo-label" data-cy="doctors-portrait-label">Portrait</div>
                  <div class="logo-area" data-cy="doctors-portrait-area">
                    <img class="logo-image" *ngIf="portraitDocument"
                      [src]="getImageUrl('PortraitDocumentID', portraitDocument)" data-cy="doctors-portrait-image" />
                  </div>
                  <div class="logo-footer" style="background-color: var(--tdo-primary); color: white;" data-cy="doctors-portrait-footer">
                    <div style="flex: 1;"></div>
                    <div matTooltip="Open file to upload" (click)="onOpenFile($event, 'PortraitDocumentID')"
                      style="cursor: pointer; flex-basis: 25px" data-cy="doctors-portrait-upload-btn"><mat-icon>folder_open</mat-icon></div>
                  </div>
                </div>
                <div class="logo-item" data-cy="doctors-signature-container">
                  <div class="logo-label" data-cy="doctors-signature-label">Signature</div>
                  <div class="logo-area" data-cy="doctors-signature-area">
                    <img class="logo-image" *ngIf="signatureDocument"
                      [src]="getImageUrl('SignatureDocumentID', signatureDocument)" data-cy="doctors-signature-image" />
                  </div>
                  <div class="logo-footer" style="background-color: var(--tdo-primary); color: white;" data-cy="doctors-signature-footer">
                    <div style="flex: 1;"></div>
                    <div matTooltip="Open file to upload" (click)="onOpenFile($event,'SignatureDocumentID')"
                      style="cursor: pointer; flex-basis: 25px" data-cy="doctors-signature-upload-btn"><mat-icon>folder_open</mat-icon></div>
                  </div>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>
